

// Autogenerated 2023-05-18 09:36:21.459709
// gen_js_enum.py proto/proto/notification.proto src/lib/proto/notification.js

const NotificationType = {
  NOTIFICATION_TYPE_UNDEFINED: { value: 0, id: "NOTIFICATION_TYPE_UNDEFINED" },
  NEW_ACCOUNT: { value: 1, id: "NEW_ACCOUNT", label: "New Account" },
  DWOLLA_PAYMENT: { value: 2, id: "DWOLLA_PAYMENT", label: "Dwolla Payment" },
  DWOLLA_IAV: { value: 3, id: "DWOLLA_IAV", label: "Dwolla IAV" },
  DWOLLA_MICRODEPOSIT: { value: 4, id: "DWOLLA_MICRODEPOSIT", label: "Dwolla Microdeposit" },
  DWOLLA_PAYMENT_SOURCE: { value: 5, id: "DWOLLA_PAYMENT_SOURCE", label: "Dwolla Payment Source" },
  NEW_TDA_ACCOUNT: { value: 6, id: "NEW_TDA_ACCOUNT", label: "New TDA Account" },
  NEW_REPO_SYMBOL: { value: 7, id: "NEW_REPO_SYMBOL", label: "New Repo symbol" },
  REBALANCE_REQUEST: { value: 8, id: "REBALANCE_REQUEST", label: "Rebalance Request" },
  EMAIL_NOTIFICATION: { value: 9, id: "EMAIL_NOTIFICATION", label: "Email Notification" },
};
const NotificationQueue = {
  NOTIFICATION_QUEUE_UNDEFINED: { value: 0, id: "NOTIFICATION_QUEUE_UNDEFINED" },
  NOTIFICATION_QUEUE_OPEN: { value: 1, id: "NOTIFICATION_QUEUE_OPEN" },
  NOTIFICATION_QUEUE_CLOSED: { value: 2, id: "NOTIFICATION_QUEUE_CLOSED" },
  NOTIFICATION_QUEUE_CANCELED: { value: 3, id: "NOTIFICATION_QUEUE_CANCELED" },
};
const EmailNotificationScope = {
  EMAIL_NOTIFICATION_TYPE_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_TYPE_UNDEFINED" },
  USER_SCOPE: { value: 1, id: "USER_SCOPE" },
  ACCOUNT_SCOPE: { value: 2, id: "ACCOUNT_SCOPE" },
};
const EmailNotificationOp = {
  EMAIL_NOTIFICATION_OP_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_OP_UNDEFINED" },
  ENQUEUE_NOTIFICATION: { value: 1, id: "ENQUEUE_NOTIFICATION" },
  SEND_EMAIL: { value: 2, id: "SEND_EMAIL" },
};
const EmailNotificationId = {
  EMAIL_NOTIFICATION_ID_UNDEFINED: { value: 0, id: "EMAIL_NOTIFICATION_ID_UNDEFINED" },
  REGULATORY_COMM_YEARLY: { value: 1, id: "REGULATORY_COMM_YEARLY" },
  REGULATORY_COMM_QUARTERLY: { value: 2, id: "REGULATORY_COMM_QUARTERLY" },
};
export { NotificationType,NotificationQueue,EmailNotificationScope,EmailNotificationOp,EmailNotificationId };
